import { apiClient, assertOk, jsonHeaders } from '@api/common'
import {
  type UserPreferenceResponse,
  type UserPreferenceValue,
  type UserPreferencesResponse,
} from '@app-types/api/preferences'

export async function fetchUserPreferences() {
  const response = await apiClient.get<UserPreferencesResponse>(
    '/api/user-preferences/',
  )

  assertOk(response, 'Не удалось загрузить пользовательские настройки')

  return response.data.preferences
}

export async function saveUserPreference(
  key: string,
  value: UserPreferenceValue,
  csrfToken: string,
) {
  const response = await apiClient.post<UserPreferenceResponse>(
    `/api/user-preferences/${encodeURIComponent(key)}/`,
    { value },
    {
      headers: jsonHeaders(csrfToken),
    },
  )

  assertOk(response, 'Не удалось сохранить пользовательскую настройку')

  return response.data.value
}
